import React from 'react';
import { ChevronRight, ChevronDown } from 'lucide-react';

const CollapsiblePanel = ({ title, isOpen, onToggle, children }) => {
  return (
    <>
      <button
        onClick={onToggle}
        className="w-full flex items-center justify-between text-left transition-colors"
        style={{
          padding: '9.66px 11.2px',
          backgroundColor: '#424241',
          color: '#ffffff',
          fontSize: '10.78px'
        }}
      >
        <span>{title}</span>
        {isOpen ? <ChevronDown size={11.2} /> : <ChevronRight size={11.2} />}
      </button>
      {isOpen && (
        <div className="p-3" style={{ backgroundColor: '#2a2a2a' }}>
          {children}
        </div>
      )}
      <div 
        className="w-full"
        style={{
          height: '4px',
          backgroundColor: '#000000'
        }}
      />
    </>
  );
};

export default CollapsiblePanel;
